// extracted by mini-css-extract-plugin
export default {"root":"Cv6gcepJAb5RdbFN2AUL","th":"wIquYfDbqt6769FQuUPE","thContent":"A3lc11bA0LQe8PhXrU0m","placeHolderShimmer":"SQrKV25lIX_INzVazD86"};